var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.84,2a10,10,0,1,0,10,10A10,10,0,0,0,11.84,2Zm0,17.92A7.92,7.92,0,1,1,19.75,12,7.93,7.93,0,0,1,11.84,19.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.55,11.43l0-4.47a1,1,0,1,0-2.08,0l0,5s0,.06,0,.09a.94.94,0,0,0,0,.16,1.42,1.42,0,0,0,.07.22l.1.14a1.25,1.25,0,0,0,.08.12l.07.05.05,0,4,3a1,1,0,0,0,1.25-1.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/duration.b7fe310be84278fa6a2663de316249a3.svg";
export { ForwardRef as ReactComponent };